<template>
  <slot :remove="remove" />
</template>

<script setup lang="ts">
import { useRenderNotifier } from '@wui/common-library'
import { HistoryMessageItem, MessageIncomingEvent, MessageOutgoingEvent, useIM } from '@wui/im'
import { ref } from 'vue'

import { useChatMessageStore } from '@/entities/messages'

import { useLocalization } from '@/shared/composables/localization'

const props = defineProps<{
  event: HistoryMessageItem<MessageIncomingEvent | MessageOutgoingEvent>
  cookie: string
}>()

const { notifyError } = useRenderNotifier()
const { t } = useLocalization()

const loading = ref(false)
const remove = async () => {
  try {
    const { updateMessageText } = useChatMessageStore()
    loading.value = true
    const files = props.event.item.files?.filter((file) => file.filecookie !== props.cookie)
    const { eventId, item, timestamp, rank, status } = await useIM().editMessage({
      targetEventId: props.event.eventId ?? 0,
      text: props.event.item.messageText!,
      to: props.event.item.pServed,
      files: files!,
    })
    updateMessageText({
      eventId,
      type: 0,
      timestamp,
      rank,
      status,
      item,
    })
  } catch (e: unknown) {
    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
    console.error(e)
  } finally {
    loading.value = false
  }
}
</script>
